<template>
  <div class="w-full flex flex-row justify-center" :class="isMobileDevice ? 'mb-12' : ''">
    <button
      v-if="!reverseButton"
      @click="$emit('next-section')"
      class="scroll-button mb-8 md:mb-4 h-20 w-20 sm:w-32 sm:h-32 md:h-36 md:w-36 z-10"
    >
      <section-scroll-icon />
    </button>

    <div
      class="flex bg-black rounded-full text-white px-4 py-2 font-bold pointer-events-auto absolute bottom-0 mx-auto uppercase md:text-lg cursor-pointer button-style"
    >
      <button @click="$emit('previous-section')">
        <section-redirect-icon v-if="reverseButton && allowReverseScroll" class="mr-4 rotate-180" />
      </button>
      {{ $t("scroll") }}
      <button @click="$emit('next-section')">
        <section-redirect-icon v-if="reverseButton" class="ml-4" />
      </button>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import SectionScrollIcon from "./SectionScrollIcon";
import SectionRedirectIcon from "./SectionRedirectIcon";

export default {
  data() {
    return {
      reverseButton: false,
      isMobileDevice: false,
    };
  },

  props: {
    allowReverseScroll: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  components: {
    SectionScrollIcon,
    SectionRedirectIcon,
  },
  mounted() {
    this.reverseButton =
      (this.$device.android || this.$device.ios) &&
      this.$route.path !== "/" &&
      this.$route.path !== "/de" &&
      this.$route.path !== "/en";
    this.isMobileDevice = this.$device.android || this.$device.ios;

    !this.reverseButton && this.runButtonLoop();
  },
  methods: {
    runButtonLoop() {
      const timeline = gsap.timeline({ repeat: -1, delay: 0 });
      if (this.reverseButton) {
        timeline
          .set(".scroll-button", { x: "-10" })
          .to(".scroll-button", { duration: 1, x: "10", ease: "power2.inOut" })
          .to(".scroll-button", { duration: 1, x: "-10", ease: "power2.inOut" });
      } else {
        timeline
          .set(".scroll-button", { y: "0" })
          .to(".scroll-button", { duration: 1, y: "20", ease: "power2.inOut" })
          .to(".scroll-button", { duration: 1, y: "0", ease: "power2.inOut" });
      }
    },
  },
};
</script>

<style scoped>
.rotate-180 {
  transform: rotate(180deg);
}
</style>
